import { useEffect } from "react";
import { createBrowserRouter, Outlet, RouterProvider, useLocation, Navigate } from "react-router-dom";
import Home from "./pages/home/home";
import Navbar from "./components/navbar/navbar";
import Sidebar from "./components/sidebar/sidebar";
import Footer from "./components/footer/footer";
import View from "./pages/view/view";
import Edit from "./pages/edit/edit";
import NotFound from "./pages/notfound/notfound";
import Weingut from "./pages/weingut/weingut";
import Login from "./pages/login/login";
import moment from 'moment';
import 'moment/locale/de';
moment.locale('de')

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

// PrivateRoute-Komponente für geschützte Routen
const PrivateRoute = ({ children }) => {
  const isAuthenticated = localStorage.getItem('token');
  if (!isAuthenticated) {
    return <Navigate to={"/login"} />;
  }
  return children;
};

function App() {

  const Layout = () => {
    return (
      <div className="site">
        <Navbar />
        <ScrollToTop />
        <div className="main">
          <Outlet />
        </div>
        <Sidebar />
        <Footer />
      </div>
    )
  }

  const router = createBrowserRouter([
    {
      path: "/",
      element: <Layout />,
      children: [
        {
          path: "/",
          element: <Home />,
        },
        {
          path: "/post/:id",
          element:  <View />,
        },
        {
          path: "/post/:id/edit",
          element: (
            <PrivateRoute>
              <Edit />
            </PrivateRoute>
          ),
        },
        {
          path: "/post/neu",
          element: (
            <PrivateRoute>
              <Edit />
            </PrivateRoute>
          ),
        },
        {
          path: "/:id",
          element: <Weingut />,
        },
        {
          path: "*",
          element: <NotFound />,
        },
      ],
    },
    {
      path: "/login",
      element: <Login />,
    },
  ]);

  return (
    <RouterProvider router={router} />
  );
}

export default App;
